import useLocales from "../../hooks/useLocales";
import { GridColDef } from "@mui/x-data-grid";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";
import { useEffect, useState } from "react";
import { ApiSlice, useGetListQuery } from "../../features/api/Api";
import { customerKindOptions, isExists, locale, params } from "../../utils";
import { useUser } from "../../hooks";
import { Button, Grid } from "@mui/material";
import CustomerListFilter from "../applications/common/CustomerListFilter";
import { useAppDispatch } from "../../app/hooks";
import Swal from "sweetalert2";
import {
  MetaTags,
  List,
  MuiDatagrid,
  ListEditButton,
  EnumField,
} from "../../components";

const CustomerList = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const { translate } = useLocales();
  const { user } = useUser();
  const [customerParams, setCustomerParams] = useState<any>({
    resource: `fixity/customer/customer/CustomersInBusinessPartner`,
    params: {
      ...params,
      filter: {
        IsMasked: true,
      },
    },
  });

  const { data: dealers, isFetching: isLoading } =
    useGetListQuery<any>(customerParams);

  const categoryActions = (
    <>
      {/* <Link to="/basvurular/create">
        <IconButton
          className="btn btn-light "
          icon="icon-plus"
          label={translate("create_new")}
          styles={{ marginLeft: "15px" }}
        />
      </Link> */}
    </>
  );

  const getAllCustomersServicesReport = async () => {
    const result: any = await dispatch(
      ApiSlice.endpoints.getList.initiate({
        resource: `fixity/athena/CustomerReport/activeServicesForCustomersInBusinessPartner`,
        params: {
          ...params,
          filter: {
            isDeleted: false,
          },
        },
      })
    );

    const { data: customers }: any = result;
    if (customers?.isSuccessful) {
      setLoading(false);
      const a = document.createElement("a");
      a.rel = "noopener noreferrer";
      a.href = `data:${customers?.data?.contentType};base64,${customers?.data?.fileBase64}`;
      a.target = "_blank";
      a.download = customers?.data?.fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      setLoading(false);
      Swal.fire("Hata!", customers?.errors[0], "error");
    }
  };

  const columns: GridColDef[] = [
    {
      field: "customerCode",
      headerName: "Müşteri Kodu",
      flex: 1,
    },
    {
      field: "title",
      headerName: translate("company_name"),
      flex: 1,
    },
    {
      field: "citizenOrTaxNumber",
      headerName: translate("resources.customers.tcknVkn"),
      flex: 1,
    },
    {
      field: "customerKindId",
      headerName: translate("resources.customers.kind"),
      flex: 1,
      renderCell: ({ value }) => (
        <EnumField
          data={value}
          options={locale(customerKindOptions, "resources.customers.")}
        />
      ),
    },
    {
      field: "debit",
      headerName: "Toplam Borç",
      flex: 1,
      renderCell: (params) => {
        return <TotalDebitCell id={params.row.id} />;
      },
      valueGetter: (params) => {
        return "test";
      },
    },
    {
      field: translate("actions.edit"),
      headerName: "",
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      align: "center",
      width: 50,
      renderCell: (params) => (
        <ListEditButton data={params} path={"customer_general"} />
      ),
    },
  ];

  const submitCustomerExport = async () => {
    setLoading(true);
    const res: any = await dispatch(
      ApiSlice.endpoints.getList.initiate({
        resource:
          "fixity/athena/excelReport/customers-in-business-partner-report",
        params: {
          ...params,
          filter: {
            IsMasked: true,
          },
        },
      })
    );
    const { data: customers }: any = res;
    if (!customers.errors) {
      setLoading(false);
      const a = document.createElement("a");
      a.rel = "noopener noreferrer";
      a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${customers.data}`;
      a.target = "_blank";
      a.download = "musteri-raporu";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      setLoading(false);
      Swal.fire("Hata!", "Dosya İndirilemedi", "error");
    }
  };
  return (
    <>
      <MetaTags
        title={translate("customers")}
        keyword="Bayi"
        description="Customer List Page"
      />
      <List
        tableName={translate("customers")}
        actions={categoryActions}
        //loading={isLoading}
      >
        <Grid container>
          <Grid item md={12} sm={12} lg={12}>
            <Grid container justifyContent="center" spacing={3}>
              <Grid item md={3} sm={6} lg={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={submitCustomerExport}
                  disabled={loading ? true : false}
                >
                  Müşteri Dışa Aktar
                </Button>
              </Grid>
              <Grid item md={3} sm={6} lg={3}>
                <Button
                  variant="contained"
                  onClick={getAllCustomersServicesReport}
                  fullWidth
                >
                  Müşteri Detayı Dışa Aktar
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} sm={12}>
            <MuiDatagrid
              loading={isLoading}
              rows={isExists(dealers?.data) ? dealers.data : []}
              columns={columns}
              rowCount={dealers?.totalItemCount}
              pageSize={customerParams.params.pagination.size}
              pageNumber={customerParams.params.pagination.pageNumber}
              setPagination={setCustomerParams}
              filters={<CustomerListFilter onSubmit={setCustomerParams} />}
              hideToolbars={{ ...defaultToolbar, search: false, create: false }}
            />
          </Grid>
        </Grid>
      </List>
    </>
  );
};

export default CustomerList;

const TotalDebitCell = ({ id }: { id: string }) => {
  const dispatch = useAppDispatch();
  const [debit, setDebit] = useState<any>(null);

  const getDebit = async () => {
    const result: any = await dispatch(
      ApiSlice.endpoints.getOneById.initiate({
        resource: `fixity/invoice/Invoice/GetDebitByCustomerId`,
        id,
      })
    );
    //let dataDebit = debit.data;
    if (result.data.isSuccessful || result.data.data.length > 0) {
      setDebit(result.data.data);
    } else {
      setDebit("Borç Yoktur.");
    }
  };
  useEffect(() => {
    getDebit();
  }, [id]);
  return (
    <div>
      {debit && debit.length > 0 && (
        <>
          {debit
            .map((item: any, index: number) => item.price + " " + item.currency)
            .join(", ")}
        </>
      )}
    </div>
  );
};
